import React, { createContext, useContext, useState } from 'react';

import styles from './index.module.scss';

interface NavbarContext {
  isOpened: boolean;
  toggle: () => void;
}

const DEFAULT_STATE = {
  isOpened: false,
  toggle: () => undefined,
};

const NavbarContext = createContext<NavbarContext>(DEFAULT_STATE);

interface NavbarProviderProps {
  children: React.ReactNode;
}

export const NavbarProvider = (props: NavbarProviderProps) => {
  const { children } = props;

  const [isOpened, setOpened] = useState(DEFAULT_STATE.isOpened);

  const toggle = () => {
    setOpened((isOpened) => !isOpened);
    document.body.classList[isOpened ? 'remove' : 'add'](styles.preventScroll);
  };

  return <NavbarContext.Provider value={{ isOpened, toggle }}>{children}</NavbarContext.Provider>;
};

export const useNavbar = () => useContext(NavbarContext);
